import { createDynamicThunk } from ".";

export const getDiemListThunk = createDynamicThunk({
  typePrefix: "diems/getDiemListThunk",
  useHandleSearch: true,
});

export const addDiemThunk = createDynamicThunk({
  typePrefix: "diems/addDiemThunk",
  endpoint: "/diems",
  method: "POST",
  refreshList: true,
  listThunk: getDiemListThunk,
});

export const editDiemThunk = createDynamicThunk({
  typePrefix: "diems/editDiemThunk",
  endpoint: "/diems",
  method: "PUT",
  refreshList: true,
  listThunk: getDiemListThunk,
  transformResponse: (response) => response,
});

export const deleteDiemThunk = createDynamicThunk({
  typePrefix: "/deleteDiemThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getDiemListThunk,
});
